import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form/immutable";
import { withStyles } from "@material-ui/core/styles";
import { formValueSelector } from "redux-form/immutable";
import React, { PureComponent, createElement } from "react";

import {
  Grid,
  Button,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import { withModal } from "altus-ui-components";

import ModalTab from "app/components/Modal/ModalTab";
import ModalTabs from "app/components/Modal/ModalTabs";
import LoadingButton from "app/components/LoadingButton";
import ModalHeader from "app/components/Modal/ModalHeader";
import { createGuid, invokeIfFunction } from "utils/app.util";
import { getFormInitialValueFromState } from "app/app.selectors";

const ModalItemTitle = ({ itemTitle, classes }) => (
  <Grid
    xs
    item
    container
    alignItems="center"
    className={classes.itemTitleContainer}
  >
    <Typography variant="h6" className={classes.itemTitle}>
      {itemTitle}
    </Typography>
  </Grid>
);

const SimpleModal = ({
  open,
  Icon,
  form,
  Icons,
  title,
  onEnter,
  onSubmit,
  children,
  component,
  submitText,
  FormProps,
  submitting,
  toggleModal,
  handleSubmit,
  DialogProps,
  ModalTitle,
  formTitleField,
  ModalActions,
  DialogContentProps,
  valid,
  Tabs,
  displaySubmitBtn,
  displayCancelBtn,
  ModalTabsProps,
  ModalTabProps,
  TabsProps,
  asyncValidating,
  ModalActionsProps,
  renderTabs,
  ...rest
}) => {
  const submit = handleSubmit(onSubmit(toggleModal));

  return (
    <Dialog
      fullWidth
      open={open}
      TransitionProps={{
        onEnter,
      }}
      onClose={toggleModal}
      {...DialogProps}
    >
      <ModalHeader title={title} toggleModal={toggleModal} />
      {Icon && !Icons && !Tabs && (
        <ModalTabs {...ModalTabsProps}>
          <ModalTab disabled {...ModalTabProps}>
            <Icon color="secondary" />
          </ModalTab>
          <ModalTitle formTitleField={formTitleField} />
        </ModalTabs>
      )}
      {Icons && !Icon && !Tabs && (
        <ModalTabs {...ModalTabsProps}>
          {Icons.map((Icon, index) => (
            <ModalTab key={index} disabled {...ModalTabProps}>
              <Icon color="secondary" />
            </ModalTab>
          ))}
          <ModalTitle formTitleField={formTitleField} />
        </ModalTabs>
      )}
      {Tabs && (
        <Tabs
          formValueSelector={formValueSelector(form)}
          {...TabsProps}
          {...rest}
        />
      )}
      {invokeIfFunction(renderTabs, {
        formValueSelector: formValueSelector(form),
        ...rest,
      })}
      <DialogContent {...DialogContentProps}>
        {component &&
          createElement(component, {
            handleSubmit: submit,
            formValueSelector: formValueSelector(form),
            ...rest,
            ...FormProps,
          })}
        {children}
      </DialogContent>
      <DialogActions>
        <>
          {displayCancelBtn && <Button onClick={toggleModal}>Cancel</Button>}
          {ModalActions && (
            <ModalActions
              valid={valid}
              submitting={submitting}
              toggleModal={toggleModal}
              {...ModalActionsProps}
            ></ModalActions>
          )}
          {displaySubmitBtn && (
            <LoadingButton
              form={form}
              type="submit"
              color="primary"
              disabled={!valid || submitting || !!asyncValidating}
              loading={submitting}
              variant="contained"
              onClick={submit}
            >
              {submitText}
            </LoadingButton>
          )}
        </>
      </DialogActions>
    </Dialog>
  );
};

SimpleModal.defaultProps = {
  displaySubmitBtn: true,
  displayCancelBtn: true,
};

const styles = theme => ({
  itemTitleContainer: {
    marginLeft: theme.spacing(-2),
  },
  itemTitle: {
    color: theme.altus.background.header,
  },
});

class SimpleFormModal extends PureComponent {
  constructor(props) {
    super(props);

    const { modalId, form, formTitleField } = props;

    this.ConnectedSimpleModal = compose(
      withModal(modalId || createGuid()),
      reduxForm(form),
    )(SimpleModal);

    this.ModalItemTitle = compose(
      connect(state => ({
        itemTitle: getFormInitialValueFromState(
          state,
          form.form,
          formTitleField,
        ),
      })),
      withStyles(styles),
    )(ModalItemTitle);
  }

  render() {
    const { ConnectedSimpleModal, ModalItemTitle } = this;
    const { form, ...rest } = this.props;

    return <ConnectedSimpleModal ModalTitle={ModalItemTitle} {...rest} />;
  }
}

export default SimpleFormModal;
